import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Scaffold } from 'layouts';
import { FormPageHeader } from 'components/Shared';
import { DriverCreationForm } from 'components/Pages/Drivers';
import * as S from './styles';

export const DriverCreationPage: React.FC = () => {
  const navigate = useNavigate();

  const onCreate = useCallback((): void => {
    navigate('/configuracoes/motoristas');
  }, [navigate]);

  return (
    <Scaffold>
      <S.PageContainer>
        <S.MainPanel>
          <FormPageHeader
            title="Novo motorista"
            icon={<S.UserRectangleIcon />}
            actions={
              <S.LinkButton size="small" to="/configuracoes/motoristas">
                <S.ArrowLeftIcon /> Voltar
              </S.LinkButton>
            }
          />
          <DriverCreationForm onCreate={onCreate} />
        </S.MainPanel>
      </S.PageContainer>
    </Scaffold>
  );
};
